/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Arrow Left 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M8.605 4.288a1 1 0 0 1 .01 1.414L3.39 11H23a1 1 0 1 1 0 2H3.39l5.224 5.298a1 1 0 1 1-1.424 1.404l-6.902-7a1 1 0 0 1 0-1.404l6.902-7a1 1 0 0 1 1.415-.01Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath>
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowLeftIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'arrow-left-icon'}
      icon={ArrowLeft}
      {...props}
      size={size}
    />
  );
};
